"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchPagesByTerm = fetchPagesByTerm;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

function fetchPagesByTerm(term, offset) {
  return _apiClient.default.get('contentsearch/v2/search/internal', {
    query: {
      q: term,
      offset: offset
    }
  });
}